import React from "react";

const F404 = () => (
    <div>
        404 Error, The Page Your Trying to load doesn't exist.
    </div>
)

export default F404;